import { apiCreate } from './ApiBaseActions';
export const API_CREATE_USER_REGISTRATION = 'API_CREATE_USER_REGISTRATION';
export const API_CREATE_USER_REGISTRATION_SUCCESS = 'API_CREATE_USER_REGISTRATION_SUCCESS';
/**
 * @deprecated TS化済 src/actions/RegistrationActions/create.ts(TODO: 検証終わり次第削除)
 * @returns
 */
export const apiCreateUserRegistration = (data, option) => apiCreate(API_CREATE_USER_REGISTRATION, '/registration', Object.assign(Object.assign({}, data), { registrationUrl: data.registrationUrl || window.location.href }), option);
